import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import { IJobZone } from "../../JobZone.model";

import classes from "./DeleteJobZonePopup.module.scss";

type DeleteJobZonePopupProps = {
  onHide: () => void;
  onConfirm: (item: IJobZone) => void;
  item: IJobZone | null;
  deleteRequestPending: boolean;
};

export const DeleteJobZonePopup = ({
  onHide,
  item,
  onConfirm,
  deleteRequestPending,
}: DeleteJobZonePopupProps) => {
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text p-secondary"
        onClick={onHide}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => item && onConfirm(item)}
        disabled={deleteRequestPending}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={true}
      style={{ width: "450px" }}
      header="Confirm"
      modal
      footer={deleteProductDialogFooter}
      onHide={onHide}
      draggable={false}
    >
      <div className={classes.content}>
        <i
          className="pi pi-exclamation-triangle mr-3"
          style={{ fontSize: "2rem", marginRight: "5px" }}
        />
        {item && (
          <span>
            Are you sure you want to delete <b>{item.name}</b>?
          </span>
        )}
      </div>
    </Dialog>
  );
};
